// extracted by mini-css-extract-plugin
export default {"root":"general_page_layout_root__y6naH","giftCardStoreContent":"general_page_layout_giftCardStoreContent__kbssH"};